import { useMemo } from 'react'
import * as actions from '@actions'
import { getUserFullName } from '@utils'
import { relativeTime } from '@utils/date'
import { toast } from 'react-toastify'
import cn from 'clsx'

import { FaTrash } from 'react-icons/fa'

const OrgJoinRequestsTable = ({
    className,
    organizations,
    setPendingDeleteOrgJoinRequest,
}) => {
    
    const requests = useMemo(() => (
        organizations?.flatMap(org => {
            return org.joinRequests.flatMap(it => ({
                ...it,
                organization: org,
            }))
        }) ?? []
    ), [organizations])
    
    const validRequests = requests.filter(request => {
        const requesterId = request.requesterId
        const memberIds = request.organization.members.map(member => member.id)
        
        return !memberIds.includes(requesterId)
    })
    
    const onApproveRequestClick = async request => {
        
        try {
            
            await actions.approveOrganizationJoinRequest(request.organization.id, request.id)
            await actions.fetchOrgs()
            
        } catch (e) {
            
            console.error('onApproveRequestClick', e)
            
            if (e.response && e.response.status === 409)
                toast.error('Already a member of this organization')
            else
                toast.error('Failed to approve join request. Please try again.')
            
        }
        
    }
    
    if (validRequests.length < 1) return null 
    
    return (
        
        <div className={cn('OrgJoinRequestsTable mt-4', className)}>
            
            <div className="bg-accent/10 p-4 rounded">
                
                <h4 className="text-xl">Join Requests</h4>
                <p>
                    The following users have requested to join one or more of your organizations.
                </p>
                
                <table className="w-full mt-3 table-auto">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Created</th>
                            <th>Organization</th>
                            <th>{/* Actions */}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {validRequests?.map(it => (
                            <tr key={`organization-${it.id}`}>
                                <td>{getUserFullName(it.requester)}</td>
                                <td>{it.requester?.email}</td>
                                <td>{relativeTime(it.createdAt)}</td>
                                <td>{it.organization?.name}</td>
                                <td>
                                    <div className="flex items-center content-center justify-end">
                                        <button
                                            className="w-auto btn btn-sm btn-success"
                                            title="Approve Request"
                                            onClick={() => onApproveRequestClick(it)}>
                                            Approve Request
                                        </button>
                                        <button
                                            className="w-auto text-red-800 btn btn-link hover:text-red-500"
                                            title="Delete Request"
                                            onClick={() => setPendingDeleteOrgJoinRequest(it)}>
                                            <FaTrash />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            
            </div>
        
        </div>
        
    )
    
}

export default OrgJoinRequestsTable
